import type { SelectProps } from '@mantine/core';
import { Select as MantineSelect } from '@mantine/core';
import React from 'react';

import styles from './Select.module.css';

export const LBSelect = React.forwardRef<
  React.ElementRef<typeof MantineSelect>,
  SelectProps
>((props: SelectProps, ref) => (
  <MantineSelect
    {...props}
    ref={ref}
    classNames={styles}
    withCheckIcon={false}
  />
));
